 

/* 
// =============================== 
// https://github.com/ag-grid/ag-grid-vue-example/issues/7
// Workaround: remove ag-grid warnings caused by vue properties
// e.g. ag-grid: invalid gridOptions property '__ob__' did you mean any of these: 
// TODO: check if this is needed for newer versions of vue or ag-grid
import { PropertyKeys } from "ag-grid/dist/lib/propertyKeys";
import { ColDefUtil } from "ag-grid/dist/lib/components/colDefUtil"; 
PropertyKeys.ALL_PROPERTIES.push("__ob__");
ColDefUtil.ALL_PROPERTIES.push("__ob__"); 
// ===============================
*/



import 'ag-grid-vue';

import "ag-grid-community/dist/styles/ag-grid.css";
/* import "ag-grid-community/dist/styles/theme-dark.css";
import "ag-grid-community/dist/styles/theme-fresh.css"; */
import "ag-grid-community/dist/styles/ag-theme-blue.css";


